const useGetLineasTipos = () => {
  const lineasTiposOptions = [
    { value: 1, label: 'DESPACHO' },
    { value: 2, label: 'ENTREGA' },
    { value: 3, label: 'TRONCAL' },
    { value: 4, label: 'LATERAL' },
  ];

  return {
    lineasTiposOptions,
  }
}

export default useGetLineasTipos;